module.exports = __webpack_public_path__ + "static/media/topfloor.9b577909.svg";


//////////////////
// WEBPACK FOOTER
// ./src/ui/screens/occupancy/topfloor.svg
// module id = 175
// module chunks = 0